<template>
    <div class="panel__container panel__container--people">
        <header class="panel__header">
            <h2 class="panel__title">Send invites to</h2>
        </header>
        <div class="options">
            <div class="options__item">
                <h2 class="options__item__title">Team members</h2>
                <p class="options__item__description">Team members have access to multiple channels. They can create and update jobs, create their own channels and invite guests.</p>
                <p class="options__item__action">
                    <router-link to="/people/invite-team-members" class="button button--outline">Invite team members</router-link>
                </p>
            </div>
            <div class="options__item">
                <h2 class="options__item__title">Multi channel guests</h2>
                <p class="options__item__description">Multiple channel guests have access to multiple channels. They can create and update jobs, but cannot create their own channels.</p>
                <p class="options__item__action">
                    <router-link to="/people/invite-multi-channel-guests" class="button button--outline">Invite multi channel guests</router-link>
                </p>
            </div>
            <div class="options__item">
                <h2 class="options__item__title">Single channel guests</h2>
                <p class="options__item__description">Single channel guests have access to a single channel only. They can create and update jobs within this. This type of user is free.</p>
                <p class="options__item__action">
                    <router-link to="/people/invite-single-channel-guests" class="button button--outline">Invite single channel guests</router-link>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('tenant', {
            tenant: 'tenant'
        })
    }
}
</script>
